import serverCall from "../serverCall";

const createAd = async (formData) => {
  const response = await serverCall.post(`/ads`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

const getAllAds = async () => {
  const response = await serverCall.get(`/ads`);
  return response;
};

const getAdById = async (id) => {
  const response = await serverCall.get(`/ads/${id}`);
  return response;
};

const updateAd = async (id, formData) => {
  const response = await serverCall.patch(`/ads/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

const deleteAd = async (id) => {
  const response = await serverCall.delete(`/ads/${id}`);
  return response;
};

const adService = {
  createAd,
  getAllAds,
  getAdById,
  updateAd,
  deleteAd,
};

export default adService;
